import { render } from "./RetentionFactors.vue?vue&type=template&id=39512b4e"
import script from "./RetentionFactors.vue?vue&type=script&lang=js"
export * from "./RetentionFactors.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__